import React, { PureComponent } from 'react';

import { Drag } from 'components/drag';
import PropTypes from 'prop-types';

class SubtitleTimelineCueTab extends PureComponent {
  static propTypes = {
    left: PropTypes.bool,
    right: PropTypes.bool,
    onTabMove: PropTypes.func
  };

  get className() {
    const { left, right } = this.props;

    if (left) {
      return 'subtitle__timeline__cue__tab--left';
    } else if (right) {
      return 'subtitle__timeline__cue__tab--right';
    }
  }

  render() {
    return (
      <Drag onCueMove={this.onTabMove}>
        <div
          ref={(ref) => (this.timelineCueTab = ref)}
          className={`subtitle__timeline__cue__tab ${this.className}`}
        ></div>
      </Drag>
    );
  }

  onTabMove = (pixelsMoved, position) => {
    const { onTabMove } = this.props;

    onTabMove && onTabMove(position);
  };
}

export default SubtitleTimelineCueTab;
